<div class="role-manager-inner">
  <div class="form-grid">
    
    <div class="form-group">
      <label>Rol a asignar</label>
      <select class="form-control" [(ngModel)]="selectedRoleId">
        <option value="" disabled>Selecciona un rol...</option>
        <option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</option>
      </select>
    </div>

    <div class="form-group">
      <label>Nivel de Contexto</label>
      <select class="form-control" [(ngModel)]="selectedContextType" (change)="onContextTypeChange()">
        <option *ngFor="let type of contextTypes" [value]="type.id">{{ type.name }}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="showClient">
      <label>Cliente</label>
      <select class="form-control" [(ngModel)]="selectedClientId" (change)="onClientChange()">
        <option value="" disabled>Selecciona Cliente...</option>
        <option *ngFor="let c of allClients" [value]="c.id">{{ c.name || c.description }}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="showSociety">
      <label>Sociedad</label>
      <select class="form-control" [(ngModel)]="selectedSocietyId" (change)="onSocietyChange()" [disabled]="!selectedClientId">
        <option value="" disabled>Selecciona Sociedad...</option>
        <option *ngFor="let s of filteredSocieties" [value]="s.id">{{ s.name || s.description }}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="showDepartment">
      <label>Departamento</label>
      <select class="form-control" [(ngModel)]="selectedDepartmentId" (change)="onDepartmentChange()" [disabled]="!selectedSocietyId">
        <option value="" disabled>Selecciona Dpto...</option>
        <option *ngFor="let d of filteredDepartments" [value]="d.id">{{ d.name || d.description }}</option>
      </select>
    </div>

    <div class="form-group" *ngIf="showProject">
      <label>Proyecto</label>
      <select class="form-control" [(ngModel)]="selectedProjectId" [disabled]="!selectedDepartmentId">
        <option value="" disabled>Selecciona Proyecto...</option>
        <option *ngFor="let p of filteredProjects" [value]="p.id">{{ p.name || p.description }}</option>
      </select>
    </div>

    <div class="form-group button-group-inline">
      <button class="btn secondary" type="button" (click)="resetForm()">Limpiar</button>
      <button class="btn primary btn-glow" type="button" [disabled]="!isFormValid()" (click)="assignRole()">Añadir Rol</button>
    </div>

  </div>

  <div class="table-scroll-area" style="margin-top: 30px;">
    <table class="cyber-table">
      <thead>
        <tr>
          <th>Rol</th>
          <th>Contexto</th>
          <th style="text-align: center;">Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let asig of assignments">
          <td><strong style="color: #a6e22e;">{{ asig.Role?.name }}</strong></td>
          <td>{{ getContextLabel(asig) }}</td>
          <td style="text-align: center;">
            <button class="btn danger" style="padding: 4px 10px; font-size: 10px;" type="button" (click)="revokeRole(asig.id!)">REVOCAR</button>
          </td>
        </tr>
        <tr *ngIf="assignments.length === 0">
          <td colspan="3" style="text-align: center; color: #a0aec0; font-size: 12px;">
            Este usuario no tiene ningún rol asignado.
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>